import styled from 'styled-components';
import { Alert } from '@mui/material';

export const StyledAlert = styled(Alert)`
  width: 100%;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid #301d35;
  box-shadow: 0px 4px 12px rgba(8, 4, 37, 0.15);

  &.MuiAlert-filledSuccess {
    background-color: #dedafb;
    color: #080425;

    .MuiAlert-icon {
      color: #301d35;
    }
  }

  &.MuiAlert-filledError {
    background-color: #eb0000;
    color: #ffffff;
    border: 1px solid #080425;

    .MuiAlert-icon {
      color: #ffffff;
    }
  }

  &.MuiAlert-filledWarning {
    background-color: #efedfd;
    color: #080425;

    .MuiAlert-icon {
      color: #301d35;
    }
  }

  &.MuiAlert-filledInfo {
    background-color: #00b0cc;
    color: #ffffff;
    border: 1px solid #301d35;

    .MuiAlert-icon {
      color: #ffffff;
    }
  }
`;
